var React = require('react');

function Present (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M4.00971 2.99999C3.97864 2.64171 4.01803 2.26165 4.19702 1.91118C4.65656 1.01139 5.61835 0.943698 6.21422 1.02967C6.86076 1.12296 7.54834 1.42881 8.1544 1.82799C8.44395 2.0187 8.73066 2.24102 9 2.49069C9.26934 2.24102 9.55605 2.0187 9.8456 1.82799C10.4517 1.42881 11.1392 1.12296 11.7858 1.02967C12.3816 0.943698 13.3434 1.01139 13.803 1.91118C13.982 2.26165 14.0214 2.64171 13.9903 2.99999H17V8.99999H16V17H2V8.99999H1V2.99999H4.00971ZM8 4.99999L3 4.99999V6.99999H8V4.99999ZM10 4.99999V6.99999H15V4.99999L10 4.99999ZM8 8.99999H4V15H8V8.99999ZM10 15V8.99999H14V15H10Z","fill":"currentColor"}));
}

Present.defaultProps = {"width":"18","height":"18","viewBox":"0 0 18 18","fill":"none"};

module.exports = Present;

Present.default = Present;
